import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { axiosDefaultHeader, dcpBaseUrl } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import { useAuth } from './useAuth'

export interface GroupInfo {
  id: string
  name: string
  created?: number
  source?: string
  attributes?: Record<string, unknown>
}

interface GroupListResponse {
  groups: GroupInfo[]
  count: number
}

interface ResultGroupList {
  success: boolean
  info?: GroupListResponse
  message?: string
}

interface DCPGroupGetProps {
  execGroupGet: (tenant: string, start?: number, size?: number) => Promise<ResultGroupList>
  loading: loadStatus
}

// DCP APIからGroup一覧取得
export const useDCPGroupGet = (): DCPGroupGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execGroupGet = async (tenant: string, start: number = 0, size: number = 10) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(
        `${dcpBaseUrl}/Tenants/${tenant}/Groups`,
        {
          headers: header,
          params: {
            start,
            size,
          },
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }

      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execGroupGet, loading }
}
